<template>
  <div>
    <b-row class="m-0 pt-3 justify-content-center">
      <div>
       <b-img-lazy :src="require(`@/assets/logos/eatDoradoLogo.png`)" class="" style=" max-width: 90%; width: 300px; height: 200px" fluid alt="eatDorado Logo"></b-img-lazy>  
      </div>
    </b-row>
    <b-row class="m-0 mt-5 justify-content-center">
      <h1>Passwort zurücksetzen</h1>
    </b-row>
    <b-row class="m-0 mt-4 justify-content-center">
      
      <div style="width: 600px; max-width: 100%" class="mx-3">
        <h4 v-if="!contactFormSent" class="text-center">Du hast dein Passwort vergessen? </h4>

        <p class="text-center m-0 mt-3">Gib Deine E-Mail-Adresse ein und wir senden Dir eine E-Mail mit Anweisungen zum zurücksetzen des Passwortes:</p>

      <b-form class="mt-4" @submit.prevent="submitForm()">

        <b-form-group
        label="Deine E-Mail-Adresse:"
        >
          <b-form-input
            :state="form.email ? true : false"
            v-model="form.email"
            id="email"
            type="email"
            required
          ></b-form-input>
        </b-form-group>

        <p class="text-center custom-nav m-0 my-3" @click="$router.push('/login').catch(err => {})">Zur Anmeldung</p>
        
        <b-button type="submit" style="width: 100%" size="md" variant="dark">Zurücksetzen</b-button>

      </b-form>
      </div>
    </b-row>
    <Footer></Footer>
  </div>
</template>

<script>

import Footer from '@/components/Footer'
import coreData from '@/mixins/coreDataMixin'

export default {
  name: 'Passwordforgot',
  mixins: [coreData],
  data: () => {
    return {
      form: {},
    }
  },
  components: {
    Footer
  },
  computed: {
    darkMode(){
      return this.$store.getters.darkMode
    },
    contactFormSent(){
      return this.$store.getters.contactFormSent
    }
  },
  watch:{
    contactFormSent(){
      if(this.contactFormSent){
        this.form = {}
      }
    }
  },
  mounted() {
  },
  methods: {
    submitForm(){
      this.$store.dispatch('sendContactForm', this.form)
    } 
  }
}
</script>